import { CONFIG } from '../core/config';
import { LicenceModules } from './LicenceModules';
import { ViewModel } from './view-model';

export class Licence implements ViewModel {
  friendlyTypeNameSingular: string = 'Licence';
  apiRoute: string = CONFIG.apiRoutes.licence;
  customerId: string;
  maxModelLinks: number;
  currentModelLinks: number;
  status: LicenceStatus;
  statusMessage: string = '';
  licenceData: string = '';
  licencedModules: LicenceModules;
  expiryDates: {};
  loaded: boolean = false;
  localizationKey:string;
  expiryDate : Date;
  maxAssetCount: number;
  currentAssetCount : number;
  customerName: string;

  constructor() {
    this.status = LicenceStatus.None;
    this.maxModelLinks = 0;
  }

  json() {
    return this;
  }
  loadFromJson(data: any) {
    this.customerId = data.customerId;
    this.status = data.status;
    this.maxModelLinks = data.maxModelLinks;
    this.currentModelLinks = data.currentModelLinks;
    this.statusMessage = data.statusMessge;
    this.licenceData = data.licenceData;
    this.licencedModules = data.licencedModules;
    this.expiryDates = data.expiryDates;
    this.expiryDate =data.expiryDate;
    this.maxAssetCount = data.maxAssetCount;
    this.currentAssetCount = data.currentAssetCount;
    this.customerName = data.customerName;
    this.loaded = true;
    if(data.localizationKey != null){
      this.localizationKey = data.localizationKey;
    }
  }
}

export enum LicenceStatus {
  None = 0,
  Valid = 1,
  Invalid = 2,
  Expired = 3,
}
